export default __webpack_public_path__ + "static/media/icon-close-red.696975cd.svg";